import axios from "axios";
import { AGENT_API_URL } from "../../config/config";
import { api_urls } from "../../utilities";
import { getAuthorizationHeader } from "./authHeader";

export const getAgentService = async (api, params) => {
  const authHeader = getAuthorizationHeader();
  const config = {
    headers: {
      token: api_urls.service_token,
      ...(authHeader ? { Authorization: authHeader } : {}),
    },
    params: params || {},
  };

  return axios
    .get(AGENT_API_URL + api, config)
    .then((res) => res)
    .catch((error) => {
      throw error.response || error;
    });
};

export const getService = async (api, params) => {
  const authHeader = getAuthorizationHeader();
  const config = {
    headers: {
      token: api_urls.service_token,
      ...(authHeader ? { Authorization: authHeader } : {}),
    },
    params: params || {},
  };

  return axios
    .get(api_urls.base_url + api, config)
    .then((res) => res)
    .catch((error) => {
      throw error.response || error;
    });
};
